// extracted by mini-css-extract-plugin
export default {"LoaderContainer":"loader_LoaderContainer__xvKo5"};